export default "__VITE_ASSET__qDHq9NEz__"